<template>
  <transition name="slide-fade">
    <!-- <div class="container light"> -->
    <box v-show="transitionShow" style="width:60vw; height: 50vh">
      <template v-slot:body>
        <!-- <img src="@/assets/lin-4.png" class="box-lin" /> -->
        <img src="@/assets/3-1.gif" class="box-lin" />
        <img src="@/assets/book.png" class="box-book" />
        <div class="main">
          <p class="main-header">
            六二年，從美國愛我華大學國際作家工作室回來，進到辦公室，又是滿耳聽到談麻將，推牌九的聲音，很覺不舒適。〈小林來臺北〉便是在這種心境下寫出的。
          </p>
        </div>
        <div class="bottom">
          <action action-class="yellow" text="PLAY" @goNext="toVideo">
            <template v-slot:icon>
              <font-awesome-icon :icon="['fas', 'caret-right']" size="lg" />
            </template>
          </action>
        </div>
      </template>
    </box>
  </transition>
  <!-- </div> -->
</template>

<script>
import Action from "@/components/Action.vue";
import Box from "@/components/Box.vue";

export default {
  name: "Home",
  components: { Action, Box },
  data() {
    return {
      transitionShow: false
    };
  },
  methods: {
    toVideo() {
      this.$router.push("video-final");
    }
  },
  mounted() {
    setTimeout(() => {
      this.transitionShow = true;
    }, 300);
  }
};
</script>
<style lang="scss" scoped>
.main {
  padding: 2em 5em;
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .main-header {
    width: 80%;
    word-wrap: break-word;
    margin-top: 1.2em;
    font-size: 1.5em;
    font-weight: bold;
    color: #965151;
    text-align: justify;
    text-justify: inter-word;
  }
}

.bottom {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.box-book {
  position: absolute;
  bottom: 5.5em;
  left: -5.5em;
  width: 12vw;
}
.box-lin {
  position: absolute;
  bottom: -3em;
  right: -8em;
  width: 18vw;
}

.slide-fade-enter-active {
  transition: all 2s ease;
}
.slide-fade-leave-active {
  transition: all 2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
